import React from 'react';

const News = () => {
    return (
        <div>
            News page
        </div>
    );
};

export default News;